import { render } from "./DataProductsSearch.vue?vue&type=template&id=390d2cb4&scoped=true"
import script from "./DataProductsSearch.vue?vue&type=script&lang=js"
export * from "./DataProductsSearch.vue?vue&type=script&lang=js"

import "./DataProductsSearch.vue?vue&type=style&index=0&id=390d2cb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390d2cb4"],['__file',"src/components/DataProductsSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "390d2cb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('390d2cb4', __exports__)) {
    api.reload('390d2cb4', __exports__)
  }
  
  module.hot.accept("./DataProductsSearch.vue?vue&type=template&id=390d2cb4&scoped=true", () => {
    api.rerender('390d2cb4', render)
  })

}


export default __exports__